/*
state 
  needJointCheck
  needLoanVerification

todo
  unit test
*/
const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.INIT:
      return { ...state, needJointCheck: action.needJointCheck, needLoanVerification: action.needLoanVerification };
    case ACTIONS.CHECK_JOINT:
      return { ...state, needJointCheck: false };
    case ACTIONS.VERIFY_LOAN:
      return { ...state, needLoanVerification: false };
    default:
      return state;
  }
};

const getNextAction = (state) => {
  if (state.needJointCheck) return ACTIONS.CHECK_JOINT;
  else if (state.needLoanVerification) return ACTIONS.VERIFY_LOAN;
  else if (state.needJointCheck === false && state.needLoanVerification === false) return ACTIONS.REDIRECT;
};

const ACTIONS = { INIT: 'INIT', CHECK_JOINT: 'CHECK_JOINT', VERIFY_LOAN: 'VERIFY_LOAN', REDIRECT: 'REDIRECT' };

export { reducer, getNextAction, ACTIONS };
